export enum WalletProviderType {
  METAMASK = "metamask",
  WALLET_CONNECT = "wallet-connect",
  PHANTOM = "phantom",
  COINBASE = "coinbase",
  TRUST_WALLET = "trust-wallet",
  WEB3AUTH = "web3-auth",
}

export enum SocialLoginProviders {
  Google = "google",
  GitHub = "github",
  Discord = "discord",
  Telegram = "telegram",
  Steam = "steam",
  Twitch = "twitch",
  Email = "email",
  Passkey = "passkey",
  X = "x",
  Coinbase = "coinbase",
  Line = "line",
  Apple = "apple",
  Phone = "phone",
  Farcaster = "farcaster",
  Facebook = "facebook",
  Guest = "guest",
  InApp = "inApp",
}

export enum CryptoWalletProviders {
  METAMASK = "io.metamask",
  TRUST_WALLET = "com.trustwallet.app",
  BITGET = "com.bitget.web3",
  OKX = "com.okex.wallet",
  BINANCE = "com.binance.wallet",
  SAFEPAL = "com.safepal",
  TOKEN_POCKET = "pro.tokenpocket",
  BYBIT = "com.bybit",
  UNISWAP = "org.uniswap",
  ZERION = "io.zerion.wallet",
  RAINBOW = "me.rainbow",
  LEDGER = "com.ledger",
  CRYPTO_COM = "com.crypto.wallet",
  KRAKEN = "com.kraken",
  ONE_INCH = "io.1inch.wallet",
  IMTOKEN = "im.token",
  SAFE = "global.safe",
  TIMELESS = "xyz.timelesswallet",
  RONIN = "com.roninchain.wallet",
  XPORTAL = "com.elrond.maiar.wallet",
  BACKPACK = "app.backpack",
  EXODUS = "com.exodus",
  FIREBLOCKS = "com.fireblocks",
  JUPITER = "ag.jup",
  BLOCKCHAIN = "com.blockchain",
  MAGIC_EDEN = "io.magiceden.wallet",
  BIFROST = "com.bifrostwallet",
  TANGEM = "com.tangem",
  WEMIX_PLAY = "com.wemixplay",
  ROBINHOOD = "com.robinhood.wallet",
  BITCOIN = "com.bitcoin",
  MATH_WALLET = "org.mathwallet",
  BLACKFORT = "network.blackfort",
  KEPLR = "app.keplr",
  BEE = "com.bee",
  VEWORLD = "com.veworld",
  BEST_WALLET = "com.bestwallet",
  FASTEX = "com.fastex.wallet",
  VALORA = "com.valoraapp",
  PINTU = "id.co.pintu",
  CORE = "app.core.extension",
  OPERA = "com.opera",
  AURORA = "dev.auroracloud",
  CHAIN = "com.chain",
  WOMBAT = "app.wombat",
  HAHA = "me.haha",
  HUDDLN = "io.huddln",
  ONEKEY = "so.onekey.app.wallet",
  SUBWALLET = "app.subwallet",
  MODULAR = "pk.modular",
  DCENT = "com.dcentwallet",
  INTERNET_MONEY = "io.internetmoney",
  HASHPACK = "com.hashpack.wallet",
  KABILA = "app.kabila",
  SABAY = "com.sabay.wallet",
  MEW = "com.mewwallet",
  TOKOIN = "io.tokoin",
  LEAP = "io.leapwallet",
  NOVA = "io.novawallet",
  FLOW = "com.flowfoundation.wallet",
  GOODDOLLAR = "org.gooddollar",
  CVL = "network.cvl",
  BITSO = "com.bitso",
  ZENGO = "com.zengo",
  KLIP = "com.klipwallet",
  ARGENT = "xyz.argent",
  EVERSPACE = "app.everspace",
  ENJIN = "io.enjin",
  UNIULTRA = "xyz.uniultra.wallet",
  HALO = "social.halo",
  OKTO = "tech.okto",
  KRIPTOMAT = "io.kriptomat",
  XELLAR = "co.xellar",
  HAQQ = "network.haqq",
  OXALUS = "io.oxalus",
  ULLAPAY = "com.ullapay",
  ALEPHIUM = "org.alephium",
  FRONTIER = "xyz.frontier.wallet",
  OVER = "network.over",
  UNSTOPPABLE = "money.unstoppable",
  IOPAY = "me.iopay",
  TOMI = "com.tomi",
  COCA = "xyz.coca",
  COIN98 = "com.coin98",
  THOR = "org.thorwallet",
  MONARCH = "com.monarchwallet",
  LOOPRING = "io.loopring.wallet",
  METAPRO = "one.metapro.wallet",
  BURRITO = "com.burritowallet",
  MT_PELERIN = "com.mtpelerin",
  PLUS = "app.pluswallet",
  LOCALTRADE = "cc.localtrade.lab",
  UPTN = "io.uptn.dapp-web",
  HERE = "app.herewallet",
  XCAPIT = "com.xcapit",
  ZEAL = "app.zeal",
  OASYS = "com.oasys-wallet",
  COOLWALLET = "com.coolbitx.cwsapp",
  LINEN = "app.linen",
  NABOX = "io.nabox",
  FAMILY = "co.family.wallet",
  KRYSTAL = "app.krystal",
  ELLIPAL = "com.ellipal",
  YUSE = "io.yusetoken",
  WALLETNOW = "app.walletnow",
  SAAKURU = "com.saakuru.app",
  FOX = "com.foxwallet",
  PAPER = "com.withpaper",
  RICE = "io.ricewallet",
  OKSE = "io.okse",
  AKTIONARIAT = "com.aktionariat",
  CYPHER = "io.cypherhq",
  PAYBOLT = "com.paybolt",
  COMPASS = "io.compasswallet",
  PLASMA = "com.plasma-wallet",
  COSMOSTATION = "io.cosmostation",
  BYTEBANK = "org.bytebank",
  UNSTOPPABLE_DOMAINS = "com.unstoppabledomains",
  KOALA = "io.koalawallet",
  OPTO = "com.optowallet",
  MIRAI = "io.miraiapp",
  BEE_WALLET = "app.beewallet",
  SEQUENCE = "xyz.sequence",
  FIZEN = "io.fizen",
  AIRGAP = "it.airgap",
  PULSE = "org.thepulsewallet",
  HOLDSTATION = "com.holdstation",
  COINOMI = "com.coinomi",
  TRUSTEE = "com.trusteeglobal",
  WALLACY = "io.wallacy",
  JAMBO = "technology.jambo",
  BLADE = "io.bladewallet",
  KEYRING = "app.keyring",
  ABRA = "com.abra",
  PREMA = "com.premanft",
  VOLTAGE = "finance.voltage",
  BITIZEN = "org.bitizen",
  WIGWAM = "com.wigwam.wallet",
  ULTIMATE = "app.ultimate",
  CAKE = "com.cakewallet",
  FIZZ = "app.fizzwallet",
  KUCOIN = "com.kucoin",
  STICKEY = "app.stickey",
  NEON = "com.neonwallet",
  COINSTATS = "app.coinstats",
  PUNDI = "ai.pundi",
  RIPIO = "com.ripio",
  ARCULUS = "co.arculus",
  HARTI = "io.harti",
  GEMWALLET = "com.gemwallet",
  DTTD = "io.dttd",
  ZELCORE = "io.zelcore",
  THETA = "org.thetatoken",
  BLOCTO = "io.blocto",
  TELLAW = "com.tellaw",
  CTRL = "xyz.ctrl",
  CALLBACK = "is.callback",
  SUMMONERS_ARENA = "io.summonersarena",
  SAFEMOON = "com.safemoon",
  IXO = "world.ixo",
  BITPIE = "com.bitpie",
  GATEWEB3 = "net.gateweb3",
  WALLYPTO = "io.wallypto",
  ALPHA_U = "io.alpha-u.wallet.web",
  LIF3 = "com.lif3",
  AMMER = "app.ammer",
  BINANCE_US = "us.binance",
  BITPAY = "com.bitpay",
  MUZA = "co.muza",
  RAKUTEN = "jp.co.rakuten-wallet",
  RYIPAY = "app.ryipay",
  DOTA168 = "org.dota168",
  ALPHA_WALLET = "com.alphawallet",
  NOONE = "io.noone",
  MYABC = "io.myabcwallet",
  WALLET3 = "io.wallet3",
  COININN = "com.coininn",
  AMBIRE = "com.ambire",
  AVACUS = "cc.avacus",
  EASY = "me.easy",
  UTORG = "app.utorg",
  SCRAMBERRY = "io.scramberry",
  SAITAMA = "com.saitamatoken",
  SECUX = "com.secuxtech",
  OPENWALLET = "finance.openwallet",
  SHIDO = "io.shido",
  UNITY = "com.unitywallet",
  ONTO = "app.onto",
  SWAPTOBE = "com.companyname.swaptobe",
  MIDOIN = "com.midoin",
  HYPERPAY = "io.hyperpay",
  COMPETENCE = "id.competence",
  TRADESTRIKE = "io.tradestrike",
  BESC = "llc.besc",
  BABYSMART = "baby.smart",
  COINSDO = "com.coinsdo",
  IVIRSE = "com.ivirse",
  DSSECURITY = "ch.dssecurity",
  CONCORDIUM = "com.concordium",
  ZKAPE = "io.zkape",
  STATUS = "app.status",
  PITAKA = "io.pitaka",
  OZONE = "io.ozonewallet",
  MUGAMBO = "org.mugambo",
  MRHB = "network.mrhb",
  CROSSMINT = "com.crossmint",
  KONIO = "io.konio",
  LEGION = "io.legionnetwork",
  MELD = "com.meld.app",
  PLT = "io.pltwallet",
  AUTHENTREND = "com.authentrend",
  POCKIE = "io.pockie",
  KLEVER = "io.klever",
  KELP = "org.kelp",
  ETHERMAIL = "io.ethermail",
  FINTOKEN = "pro.fintoken",
  PALI = "com.paliwallet",
  UINCUBATOR = "vc.uincubator.api",
  UNAGI = "io.unagi.unawallet",
  LIBERA = "com.liberawallet",
  ARMANA = "io.armana.portal",
  X9 = "com.x9wallet",
  KIGO = "io.kigo",
  DOSI = "world.dosi.vault",
  NONBANK = "io.nonbank",
  COGNI = "com.getcogni",
  INDI = "gg.indi",
  QUBIC = "app.qubic.wallet",
  FXWALLET = "com.fxwallet",
  SINUM = "app.sinum",
  KRYPTOGO = "com.kryptogo",
  SOULSWAP = "finance.soulswap.app",
  SHAPESHIFT = "com.shapeshift",
  READY = "io.ready",
  SHEFI = "org.shefi",
  KEYCHAIN = "money.keychain",
  BEEXO = "com.beexo",
  SUPEREX = "live.superex",
  CLAVE = "io.getclave",
  BETTATRADE = "com.bettatrade",
  NEOPIN = "io.neopin",
  PUZZLE = "online.puzzle",
  ECHOOO = "xyz.echooo",
  VERSO = "com.get-verso",
  WEMIX_APP = "com.wemix",
  TRINITY = "io.trinity-tech",
  TRUSTASSET = "io.trustasset",
  DFINN = "app.dfinnwallet",
  BMA = "com.bmawallet",
  TRANSI = "io.transi",
  SAFECRYPTO = "io.safecryptowallet",
  PLENA = "finance.plena",
  CERTHIS = "io.certhis",
  TOMO = "inc.tomo",
  KOMET = "me.komet.app",
  PANDOSHI = "com.pandoshi",
  GUARDIIAN = "io.guardiianwallet",
  LIFEDEFI = "co.lifedefi",
  ZYPTO = "com.zypto",
  BROEARN = "com.broearn",
  TTM = "io.ttmwallet",
  TASTY_CRYPTO = "com.tastycrypto",
  IPMB = "com.ipmb",
  NEST = "xyz.nestwallet",
  NICEGRAM = "app.nicegram",
  BALLET = "com.ballet",
  OMNI = "app.omni",
  PARASWAP = "io.paraswap",
  MIXIN = "one.mixin.messenger",
  CRYPTOKARA = "com.cryptokara",
  CAESIUM = "com.caesiumlab",
  NODLE = "com.nodle",
  UNIVERSAL_PROFILES = "io.universaleverything",
  ISLAMI = "finance.islamicoin",
  THIRDWEB = "com.thirdweb",
  OPZ = "com.opz",
  TOBI = "fun.tobi",
  FLOOZ = "trade.flooz.wallet",
  TPLUS = "org.talkapp",
  PLUTOPE = "io.plutope",
  POOLS = "com.poolsmobility.wallet",
  ROAM = "xyz.roam.wallet",
  DEXTRADE = "com.dextrade",
  GAMIC = "app.gamic",
  FNCY = "world.fncy",
  M1NTY = "app.m1nty",
  THREE_S_WALLET = "com.3swallet",
  CATECOIN = "app.catecoin",
  PAYPERLESS = "com.payperless",
  COINCIRCLE = "com.coincircle",
  HELIXID = "io.helixid",
  PASSPAY = "io.passpay",
  KRESUS = "com.kresus",
  NUFINETES = "com.nufinetes",
  QOIN = "world.qoin",
  COPIOSA = "io.copiosa",
  ANCRYPTO = "io.ancrypto",
  KEEPER = "app.keeper-wallet",
  BHARATBOX = "io.bharatbox",
  ORION = "xyz.orion",
  CRYPTNOX = "com.cryptnox",
  BITVERSE = "zone.bitverse",
  DROPP = "cc.dropp",
  SINOHOPE = "com.sinohope",
  HAI = "ai.hacken",
  SPATIUM = "net.spatium",
  BITNOVO = "com.bitnovo",
  SWOP = "co.swopme",
  LIKERLAND = "land.liker",
  OWALLET = "io.owallet",
  DOLLET = "com.dolletwallet",
  SHINOBI = "net.shinobi-wallet",
  AZCOINER = "com.azcoiner",
  PIER = "com.pierwallet",
  TALKEN = "io.talken",
  DGPUB = "pub.dg",
  GREENHOOD = "nl.greenhood.wallet",
  ARIANEE = "org.arianee",
  SPOTONCHAIN = "ai.spotonchain.platform",
  TIDUS = "com.tiduswallet",
  OBVIOUS = "technology.obvious",
  DAFFIONE = "com.daffione",
  WEBAUTH = "com.webauth",
  TOFEE = "app.tofee",
  DIDWALLET = "io.didwallet",
  BONUZ = "xyz.bonuz",
  GM2 = "social.gm2",
  CYBERWALLET = "co.cyber.wallet",
  ASTROX = "me.astrox",
  PILLAR = "fi.pillar",
  MOONSTAKE = "io.moonstake",
  HIPPO = "io.hippowallet",
  AMAZEWALLET = "com.amazewallet",
  KRIPTONIO = "com.kriptonio",
  ALTME = "io.altme",
  UKISS = "io.ukiss",
  DROPMATE = "fi.dropmate",
  ZELUS = "io.zelus",
  XUCRE = "io.xucre",
  RENEGADE = "net.myrenegade",
  STASIS = "net.stasis",
  CLING = "io.clingon",
  HUMBL = "com.humbl",
  PEAKDEFI = "com.peakdefi",
  DGG = "network.dgg",
}
